import DeleteRuleModal from './rules/DeleteRuleModal';
import AddCameraModal from './camera/AddCameraModal';
import EditCameraModal from './camera/EditCameraModal';
import DeleteCameraModal from './camera/DeleteCamera';
import LogoutModal from './user/LogoutModal';
import AddUserModal from './user/AddUserModal';
import EditUserModal from './user/EditUserModal';
import DeleteUserModal from './user/DeleteUserModal';
import ChangePasswordModal from './user/ChangePasswordModal';
import AddZoneModal from './zone/AddZoneModal';
import EditZoneModal from './zone/EditZoneModal';
import DeleteZoneModal from './zone/DeleteZoneModal';
import AddSiteModal from './sites/AddSiteModal';
import DeleteSiteModal from './sites/DeleteSiteModal';
import EditSiteModal from './sites/EditSiteModal';
import DeleteAlertModal from './alert/DeleteAlertModal';
import ArchiveAlertModal from './alert/ArchiveAlertModal';
import useOutsideClick from '../../hooks/useOutsideClick';
import { useRef } from 'react';
import { Icon } from '../../assets/icons';
import InsufPermition from './permition/InsufPermition';
import GenerateReportModal from './report/GenerateReportModal';
import AddCameraVidModal from './camera/AddCameraVidModal';

const Modals = {
    GenerateReportModal,
    DeleteAlertModal,
    ArchiveAlertModal,
    AddSiteModal,
    DeleteSiteModal,
    EditSiteModal,
    DeleteZoneModal,
    EditZoneModal,
    AddZoneModal,
    AddUserModal,
    EditUserModal,
    DeleteUserModal,
    ChangePasswordModal,
    AddCameraModal,
    AddCameraVidModal,
    DeleteCameraModal,
    DeleteRuleModal,
    EditCameraModal,
    LogoutModal,
    InsufPermition,
};

export function Modal({ modal, ...props }) {
    const modalRef = useRef(null);

    // Close modal when clicked outside
    useOutsideClick(modalRef, props.onClose);

    // Dynamically render the selected modal
    const ModalComponent = Modals[modal];

    return (
        <div
            className={`fixed inset-0 ${props.isOpen ? 'block' : 'hidden'} bg-black bg-opacity-30 z-50 overflow-y-auto`}
        >
            <div className="flex items-center justify-center min-h-screen">
                {props.isOpen &&
                    <div
                        ref={modalRef}
                        className="relative"
                    >
                        <button
                            type="button"
                            onClick={props.onClose}
                            aria-label="Close"
                            title="Close"
                            className="absolute top-4 right-4 z-10 flex items-center justify-center w-7 h-7 rounded-md text-gray-400 hover:text-gray-600 hover:bg-gray-100"
                        >
                            <Icon icon="Close" className="w-4 h-4" />
                        </button>
                        <ModalComponent {...props} />
                    </div>
                }
            </div>
        </div>
    );
}

export default Modals;
